// extracted by mini-css-extract-plugin
export default {"actions":"U1pZsj","star":"yHKWig","starFilled":"fgjyXW","insideModal":"ht2xmz","wired":"ZvQnBI"};